import React from 'react';
import {BaseMixin, ElementaryMixin} from '../common/common.js';

import './progress-bar-cover.less';

export default React.createClass({

  //@@viewOn:mixins
  mixins: [
    BaseMixin,
    ElementaryMixin
  ],
  //@@viewOff:mixins

  //@@viewOn:statics
  statics: {
    tagName: 'UU5.Bricks.ProgressBar.Cover',
    classNames: {
      main: 'uu5-bricks-progress-bar-cover progress'
    }
  },
  //@@viewOff:statics

  //@@viewOn:propTypes
  //@@viewOff:propTypes

  //@@viewOn:getDefaultProps
  //@@viewOff:getDefaultProps

  //@@viewOn:standardComponentLifeCycle
  //@@viewOff:standardComponentLifeCycle

  //@@viewOn:interface
  //@@viewOff:interface

  //@@viewOn:overridingMethods
  //@@viewOff:overridingMethods

  //@@viewOn:componentSpecificHelpers
  //@@viewOff:componentSpecificHelpers

  //@@viewOn:render
  render: function () {
    return (
      <div {...this.buildMainAttrs()}>
        {this.props.children && React.Children.toArray(this.props.children)}
        {this.getDisabledCover()}
      </div>
    );
  }
  //@@viewOff:render
});


// WEBPACK FOOTER //
// ./bricks/progress-bar-cover.js